export default (score) => {
    if (score >= 800)
        return 'VANTAGE_SCORE_BUCKET_800_UP';
    if (score >= 750)
        return 'VANTAGE_SCORE_BUCKET_750_799';
    if (score >= 725)
        return 'VANTAGE_SCORE_BUCKET_725_749';
    if (score >= 700)
        return 'VANTAGE_SCORE_BUCKET_700_724';
    if (score >= 680)
        return 'VANTAGE_SCORE_BUCKET_680_699';
    if (score >= 625)
        return 'VANTAGE_SCORE_BUCKET_625_679';
    if (score >= 580)
        return 'VANTAGE_SCORE_BUCKET_580_624';
    if (score >= 525)
        return 'VANTAGE_SCORE_BUCKET_525_579';
    if (score >= 450)
        return 'VANTAGE_SCORE_BUCKET_450_524';
    if (score < 450)
        return 'VANTAGE_SCORE_BUCKET_LOWER_450';
    return 'VANTAGE_SCORE_BUCKET_UNSPECIFIED';
};
//# sourceMappingURL=get-vantage-score-bucket.js.map